import MuxPlayer from '@mux/mux-player-react';
import { useTranslation } from 'react-i18next';

import { useUserConsent } from 'src/Services/UserConsentProvider/context';

import styles from './VideoPlayer.module.scss';
import { Props } from './VideoPlayer.types';

/**
 * A Video Player for Mux videos.
 *
 * It have some basic styling (primary color, accent color and radius).
 *
 * It take 100% of the size of its parent.
 */
const VideoPlayer = ({ video }: Props) => {
  const isInvalid = !video.playbackId || !video.playbackToken || !video.thumbnailToken;
  const { t } = useTranslation();
  const userConsent = useUserConsent();

  if (isInvalid) {
    return (
      <div className={styles.errorContainer}>
        {video.assetStatus == 'errored' ? (
          <p className={styles.errorParagraph}>{t('videoPlayer.videoIncomplete')}</p>
        ) : (
          <p className={styles.errorParagraph}>{t('videoPlayer.videoError')}</p>
        )}
      </div>
    );
  }

  return (
    <MuxPlayer
      playbackId={video.playbackId!}
      tokens={{ playback: video.playbackToken!, thumbnail: video.thumbnailToken! }}
      className={styles.videoPlayer}
      primaryColor="white"
      accentColor="#089299"
      disableTracking={!userConsent.consentForAnalytics}
      disableCookies={!userConsent.consentForAnalytics}
    />
  );
};

export default VideoPlayer;
